import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotController } from '../../controllers/slots-ng-controller';
import { screenSizeMap } from '../../controllers/screen-size-controller';
import { ResizeController } from '../../controllers/resize-controller';
import componentStyles from './sic-home-hero.css.lit';
import componentVariables from './css-variables/sic-home-hero-vars.css.lit';

/**
 * The Home Herp component
 *
 * @element sic-home-hero
 * @since 1.0.0
 * @slot - title
 * @slot - subtitle
 * @slot - cta-items
 * @prop {String} breakpoint - layoutChange.
 */

@customElement('sic-home-hero')
export class SicHomeHero extends OutlineElement {
  static styles: CSSResultGroup = [componentVariables, componentStyles];

  slots = new SlotController(this);
  resizeController: ResizeController;
  // The resizeController is initialized here because layoutBreakpoint is not set yet when constructor runs
  connectedCallback() {
    super.connectedCallback();
    this.resizeController = new ResizeController(this, {
      breakpoints: [screenSizeMap.get(this.layoutBreakpoint) as number],
      containerQuery: false,
    });
  }

  @property({ type: String, attribute: 'breakpoint' })
  layoutBreakpoint = 'md';

  render(): TemplateResult {
    const isMobile = this.resizeController.currentBreakpointRange === 0;
    const layoutClasses = {
      'layout-container': true,
      'layout-is-mobile': isMobile,
    };
    return html`
      <div class="${classMap(layoutClasses)}">
        <div class="content">
          ${this.slots.conditionalSlot('title')}
          ${this.slots.conditionalSlot('subtitle', false)}
        </div>
        ${this.slots.conditionalSlot('cta-grid', false)}
      </div>
    `;
  }
}
